import { render } from "./TestLicnosti.vue?vue&type=template&id=46bcef76&scoped=true&lang=html"
import script from "./TestLicnosti.vue?vue&type=script&lang=js"
export * from "./TestLicnosti.vue?vue&type=script&lang=js"

import "./TestLicnosti.vue?vue&type=style&index=0&id=46bcef76&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-46bcef76"

export default script